module.exports = __webpack_public_path__ + "img/bg-footer.4661589c.svg";